/* Ficha de producto — diseño nuevo (.tt-pdp). Ver tt-pdp.css.
   1) Lleva los sellos de la colección (batería, motor…) junto al sello de potencia.
   2) Agrega "Ver disponibilidad en tienda" a la caja de retiro.
   3) Ordena la descripción: título + SKU, texto, tabla de especificaciones y lista "Incluye".
      La descripción original sigue en el HTML del servidor (Google y los asistentes la leen);
      si el texto no trae especificaciones reconocibles, se deja tal cual. */
(function () {
  var root = document.querySelector('.tt-pdp');
  if (!root || root.dataset.ttPdp) return;
  root.dataset.ttPdp = '1';

  function clean(t) {
    return String(t || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
      .replace(/^[-•·*–—]+\s*/, '').trim();
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // ---- 1) Sellos ----
  var badges = root.querySelector('.tt-badges');
  var feats = root.querySelector('.product-main [data-product-pricing] .section-features');
  if (badges && feats && !badges.querySelector('.section-features')) badges.appendChild(feats.cloneNode(true));

  // ---- 2) Retiro en tienda ----
  var hook = root.querySelector('.tt-pickup-hook');
  if (hook && !hook.querySelector('.tt-pdp-pickbtn')) {
    var b = document.createElement('span');
    b.className = 'tt-pdp-pickbtn';
    b.textContent = 'Ver disponibilidad en tienda';
    hook.appendChild(b);
  }

  // ---- 2a) "¡Solo quedan N unidades!" al lado de la cantidad (ocupa el hueco que dejaba
  //          el texto repetido "(ultimas N disponibles)") ----
  var scar = root.querySelector('.tt-buybox__card .tt-scarcity');
  var qtyRow = root.querySelector('.tt-buybox__card .form-field--qty-select');
  if (scar && qtyRow) { qtyRow.appendChild(scar); qtyRow.classList.add('tt-pdp-qtyrow'); }

  // ---- 2b) Compartir / Ayuda / Devoluciones: al final de la columna (debajo de pagos y retracto) ----
  var share = root.querySelector('.product-main .circular-buttons-section');
  var helpCol = root.querySelector('.tt-help-col');
  if (share && helpCol) helpCol.appendChild(share);
  // "Devoluciones" sigue abriendo su ventana (el cliente no sale de la ficha); dentro de la ventana,
  // link a la política completa del Centro de ayuda en una pestaña nueva.
  var retBody = document.querySelector('#returnsModal .custom-modal-body');
  if (retBody && !retBody.querySelector('.tt-pdp-helpcta')) {
    retBody.insertAdjacentHTML('beforeend',
      '<a class="tt-pdp-helpcta" href="/pages/centro-de-ayuda#cambios-y-devoluciones" target="_blank" rel="noopener">' +
      'Ver política completa en el Centro de ayuda <span aria-hidden="true">↗</span><span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>');
  }
  // El texto (Compartir, Ayuda…) también abre su ventana, no solo el ícono
  if (share) share.querySelectorAll('.button-label').forEach(function (l) {
    var b = l.parentNode.querySelector('button.circular-button');
    if (b) l.addEventListener('click', function () { b.click(); });
  });

  // ---- 2c) Preguntas frecuentes: al final de la columna de descripción (bajo las pestañas) ----
  var faq = root.querySelector('[data-tt-pdp-faq]');
  var longc = root.querySelector('.tt-longcontent');
  if (faq && longc) longc.appendChild(faq);

  // ---- 3) Descripción + ficha técnica en una sola pestaña ----
  // La ficha técnica de Mercado Libre (pestaña "Ficha técnica", HTML del servidor) es la tabla
  // principal cuando existe; la que se arma desde la descripción queda solo si no hay ficha
  // o si trae grupos (kits con dos herramientas).
  var mlPanel = root.querySelector('[data-tt-panel="spec"]');
  var ml = mlPanel && mlPanel.querySelector('.tt-ficha');
  var src = root.querySelector('.tt-desc .description-product-sp');
  var built = src ? buildDesc() : false;
  mergeFicha(built);

  function buildDesc() {

  var RX_SPEC = /^(especificaciones( t[eé]cnicas)?|caracter[ií]sticas( t[eé]cnicas)?|datos t[eé]cnicos|ficha t[eé]cnica|descripci[oó]n)$/i;
  var RX_INC = /^((el|este) (kit|set|producto) incluye|incluye|contenido( del (kit|set|paquete|empaque))?|componentes del kit|este producto se compone( de)?)$/i;


  // Líneas de texto: cada <br>, <li>, párrafo o título es una línea.
  var lines = [];
  function push(text, li) { var t = clean(text); if (t) lines.push({ t: t, li: !!li }); }
  // Listas: cada <li> es una línea (sin sus sublistas, que van después como líneas propias).
  function list(ul) {
    for (var i = 0; i < ul.children.length; i++) {
      var c = ul.children[i];
      if (c.tagName === 'UL' || c.tagName === 'OL') { list(c); continue; }
      var cp = c.cloneNode(true), subs = cp.querySelectorAll('ul,ol');
      for (var j = 0; j < subs.length; j++) subs[j].parentNode.removeChild(subs[j]);
      cp.innerHTML.split(/<br\s*\/?>/i).forEach(function (part) {
        var d = document.createElement('div'); d.innerHTML = part; push(d.textContent, true);
      });
      var inner = c.querySelectorAll(':scope > ul, :scope > ol');
      for (var k = 0; k < inner.length; k++) list(inner[k]);
    }
  }
  function walk(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) { push(n.textContent); continue; }
      if (n.nodeType !== 1) continue;
      var tag = n.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TABLE') return false;   // tablas o código: no tocar
      if (tag === 'UL' || tag === 'OL') { list(n); continue; }
      if (/^(P|DIV|H[1-6]|SECTION|ARTICLE|BLOCKQUOTE)$/.test(tag)) {
        if (n.querySelector('ul,ol,p,div,table')) { if (walk(n) === false) return false; continue; }
        n.innerHTML.split(/<br\s*\/?>/i).forEach(function (part) {
          var d = document.createElement('div'); d.innerHTML = part; push(d.textContent);
        });
        continue;
      }
      push(n.textContent);
    }
  }
  if (walk(src) === false) return false;

  var title = '', sku = '', intro = [], rows = [], feats2 = [], inc = [], mode = '';
  lines.forEach(function (l, i) {
    var t = l.t, head = t.replace(/\s*:\s*$/, '');
    var m;
    if (/^sku\s*:/i.test(t)) { sku = t.replace(/^sku\s*:\s*/i, ''); return; }
    if (RX_SPEC.test(head)) { mode = 'spec'; return; }
    if (RX_INC.test(head)) { mode = 'inc'; return; }
    // "Incluye: 2 baterías…" en la misma línea
    if ((m = t.match(/^incluye\s*:\s*(.+)$/i))) { inc.push(m[1]); mode = 'inc'; return; }
    if (mode === 'inc') { inc.push(t); return; }
    if (mode === 'spec' || l.li) {
      // "Taladro compacto:" sin valor = subtítulo de un grupo de la ficha
      if (/^[^:]{2,60}:$/.test(t)) { rows.push({ g: head }); return; }
      var kv = t.match(/^([^:]{2,45}):\s*(.+)$/);
      if (kv && !/https?$/i.test(kv[1])) { rows.push([kv[1], kv[2].replace(/\.$/, '')]); return; }
      var g = t.match(/^(garant[ií]a)\s+(?:de\s+)?(.+)$/i);
      if (g) { rows.push(['Garantía', g[2].replace(/\.$/, '')]); return; }
      if (t.length <= 140) {
        // dentro de un grupo (kits: "Taladro…:", "Esmeril…:") la característica queda en su grupo
        if (rows.some(function (r) { return r.g; })) rows.push({ f: t.replace(/\.$/, '') });
        else feats2.push(t.replace(/\.$/, ''));
        return;
      }
    }
    // Primera línea = nombre del producto (si va seguido del SKU o si está escrito en mayúsculas / sin punto final)
    if (i === 0 && t.length < 120 && ((lines[1] && /^sku\s*:/i.test(lines[1].t)) || t === t.toUpperCase() || (t.length < 90 && !/[.:]$/.test(t) && lines.length > 1))) { title = t; return; }
    intro.push(t);
  });

  // Grupos sin filas debajo no cuentan; si no hay ficha reconocible, se deja la descripción original.
  rows = rows.filter(function (r, i) { return !r.g || (rows[i + 1] && !rows[i + 1].g); });
  var groups = rows.some(function (r) { return r.g; });
  var nrows = rows.filter(function (r) { return !r.g && !r.f; }).length;
  if (!ml && nrows < 3 && !(nrows && inc.length) && inc.length < 2) return false;

  // Una sola tabla: primero los datos de la descripción (los que importan: torque, rpm…),
  // después los de la ficha de Mercado Libre que no se repitan (sin marca/modelo/logística).
  var NOISE = /^(marca|modelo( detallado)?|l[ií]nea|transportabilidad hazmat|c[oó]digo universal de producto|gtin|sku|es kit|formato de venta|unidades por (kit|pack)|incluye bater[ií]as?|incluye cargador|con indicador de carga.*)$/i;
  var norm = function (x) { return clean(x).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
  var seen = {};
  rows.forEach(function (r) { if (!r.g && !r.f) seen[norm(r[0])] = 1; });
  var mlRows = [];
  if (ml) ml.querySelectorAll('tr').forEach(function (tr) {
    var th = tr.querySelector('th'), td = tr.querySelector('td');
    if (!th || !td) return;
    var k = clean(th.textContent), v = clean(td.textContent);
    if (!k || !v || NOISE.test(k) || seen[norm(k)]) return;
    seen[norm(k)] = 1; mlRows.push([k, v]);
  });
  if (mlRows.length) {
    if (nrows) rows.push({ g: 'Más datos técnicos' });
    rows = rows.concat(mlRows);
  }
  var total = rows.length;
  if (!total && !inc.length && !feats2.length) return false;

  // Escritorio: 12 filas a la vista. Celular: 6 filas, "Incluye" y "Características" plegables
  // y el texto en 3 líneas con "Leer más" (todo sigue en la página, solo plegado).
  var LIMIT = 12, MLIMIT = 6;
  var mobile = window.matchMedia('(max-width: 1023px)').matches;
  var html = '<div class="tt-pdp-desc">';
  // (sin repetir el nombre: ya es el título principal de la página)
  if (intro.length) html += '<div class="tt-pdp-desc__intro" data-tt-pdp-intro>' + intro.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') + '</div>' +
    '<button type="button" class="tt-pdp-readmore" aria-expanded="false" hidden>Leer más</button>';
  // Sección plegable en celular (en escritorio siempre abierta)
  function fold(title, body, cls) {
    return '<details class="tt-pdp-fold ' + (cls || '') + '"' + (mobile ? '' : ' open') + '><summary><h2 class="tt-pdp-desc__h">' + title + '</h2></summary>' + body + '</details>';
  }
  var left = '';
  if (total) {
    var btn = function (cls) {
      return '<button type="button" class="tt-pdp-more ' + cls + '" aria-expanded="false" data-more="Ver todas las especificaciones (' + total + ')">Ver todas las especificaciones (' + total + ')</button>';
    };
    left += '<div class="tt-pdp-specbox' + (total > MLIMIT ? ' is-collapsed' : '') + '"><h2 class="tt-pdp-desc__h">Especificaciones</h2><table class="tt-pdp-spec"><tbody>' +
      rows.map(function (r, i) {
        var x = (i >= LIMIT ? ' tt-pdp-spec__extra' : '') + (i >= MLIMIT ? ' tt-pdp-spec__mextra' : '');
        return r.f ? '<tr class="tt-pdp-spec__f' + x + '"><td colspan="2">' + esc(r.f) + '</td></tr>'
          : r.g ? '<tr class="tt-pdp-spec__g' + x + '"><th colspan="2" scope="rowgroup">' + esc(r.g) + '</th></tr>'
          : '<tr class="' + x.trim() + '"><th scope="row">' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>';
      }).join('') + '</tbody></table>' +
      (total > MLIMIT ? btn(total > LIMIT ? '' : 'tt-pdp-more--mobile') : '') + '</div>';
  }
  if (feats2.length) {
    left += fold('Características', '<ul class="tt-pdp-list">' + feats2.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>', left ? 'tt-pdp-feat' : '');
  }
  var right = inc.length ? fold('Incluye', '<ul class="tt-pdp-list">' + inc.map(function (f) { return '<li>' + esc(f.replace(/\.$/, '')) + '</li>'; }).join('') + '</ul>', 'tt-pdp-inc') : '';
  html += '<div class="tt-pdp-desc__grid' + (left && right ? '' : ' tt-pdp-desc__grid--one') + '">' +
    (left ? '<div>' + left + '</div>' : '') + (right ? '<div>' + right + '</div>' : '') + '</div></div>';

  var box = src.closest('.tt-desc');
  if (box) { box.classList.add('is-structured'); box.removeAttribute('data-tt-desc'); }
  src.insertAdjacentHTML('beforebegin', html);
  src.hidden = true;
  var scope = src.parentNode;
  var more = scope.querySelector('.tt-pdp-more');
  if (more) more.addEventListener('click', function () {
    var sb = more.closest('.tt-pdp-specbox'), open = sb.classList.toggle('is-open');
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.textContent = open ? 'Ver menos' : more.dataset.more;
  });
  // En escritorio las secciones no se pliegan
  scope.querySelectorAll('.tt-pdp-fold > summary').forEach(function (sm) {
    sm.addEventListener('click', function (e) { if (!window.matchMedia('(max-width: 1023px)').matches) e.preventDefault(); });
  });
  // "Leer más" solo si el texto pasa de 3 líneas
  var introEl = scope.querySelector('[data-tt-pdp-intro]'), rm = scope.querySelector('.tt-pdp-readmore');
  if (introEl && rm) {
    var checkRm = function () {
      if (introEl.classList.contains('is-open')) return;
      rm.hidden = introEl.scrollHeight <= introEl.clientHeight + 2;
    };
    rm.addEventListener('click', function () {
      var open = introEl.classList.toggle('is-open');
      rm.setAttribute('aria-expanded', open ? 'true' : 'false');
      rm.textContent = open ? 'Leer menos' : 'Leer más';
    });
    // la pestaña puede estar oculta al cargar: medir cuando se vea
    if (window.ResizeObserver) new ResizeObserver(checkRm).observe(introEl); else checkRm();
  }
  return true;
  }


  // Ficha de Mercado Libre → dentro de "Descripción" (y se quita su pestaña)
  function mergeFicha(built) {
    if (!ml) return;
    var descPanel = root.querySelector('[data-tt-panel="desc"]');
    if (!descPanel) return;   // sin descripción: la ficha sigue siendo su propia pestaña
    if (!built) {
      var wrap = document.createElement('div');
      wrap.className = 'tt-pdp-ficha';
      wrap.innerHTML = '<h2 class="tt-pdp-desc__h">Especificaciones</h2>';
      wrap.appendChild(ml);
      descPanel.appendChild(wrap);
    }
    var btn = root.querySelector('[data-tt-tab="spec"]');
    if (btn) btn.remove();
    mlPanel.remove();
  }
})();
